import { createGlobalStyle, css } from 'styled-components';
const DefaultFonts = createGlobalStyle `${css `
	@font-face {
		font-family: 'CoreFont';
		src:
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-400-normal.woff2) format('woff2'),
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-400-normal.woff) format('woff'),
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-400-normal.ttf) format('truetype');
		font-display: swap;
		font-style: normal;
		font-weight: 400;
	}

	@font-face {
		font-family: 'CoreFont';
		src:
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-500-normal.woff2) format('woff2'),
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-500-normal.woff) format('woff'),
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-500-normal.ttf) format('truetype');
		font-display: swap;
		font-style: normal;
		font-weight: 500;
	}

	@font-face {
		font-family: 'CoreFont';
		src:
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-700-normal.woff2) format('woff2'),
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-700-normal.woff) format('woff'),
			url(https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-700-normal.ttf) format('truetype');
		font-display: swap;
		font-style: normal;
		font-weight: 700;
	}
`}`;
export default DefaultFonts;
//# sourceMappingURL=fonts.js.map